export const API_URL ='https://aiaura.co.uk/api/';

export const backendUrl = 'api/'

export const SITE_URL =  "aiaura.co.uk" // adjust to your site URL;

// Example endpoint URL for workers API
export const workersEndpoint = `${API_URL}workers/`;

// Example endpoint URL for lang API
export const langEndpoint = `${API_URL}lang/`;

export const generalEndpoint = `${API_URL}general/`;

// Example endpoint URL for authy API
export const authyEndpoint = `${API_URL}authy/`;

export const jobsEndpoint = `${API_URL}jobs/`;

export const invitesEndpoint = `${API_URL}invites/`;

export const feedbackEndpoint = `${API_URL}feedback/`;

export const profilesEndpoint = `${API_URL}profile_actions/`;

export const usersEndpoint = `${API_URL}users/`;

export const offersEndpoint = `${API_URL}offers/`;

export const mapsEndpoint = `${API_URL}maps/`;

export const paymentsEndpoint = `${API_URL}subscriptions/`;

export const partnersEndpoint = `${API_URL}partners/`;

export const productsEndpoint = `${API_URL}products/`;

export const folioEndpoint = `${API_URL}folio/`;

export const collabEndpoint = `${API_URL}collab/`;

export const chatEndpoint = `${API_URL}chat/`;

export const followEndpoint = `${API_URL}follow/`;

export const managementEndpoint = `${API_URL}management/`;

export const boardsEndpoint = `${API_URL}boards/`;

export const clientsEndpoint = `${API_URL}clients/`;
// Use these endpoint URLs in your React components to make API requests

export const colors = [
    ["#0079bf", false],
    ["#70b500", false],
    ["#ff9f1a", false],
    ["#eb5a46", false],
    ["#f2d600", false],
    ["#c377e0", false],
    ["#ff78cb", false],
    ["#00c2e0", false],
    ["#51e898", false],
    ["#c4c9cc", false],
];